import React from 'react'

export default () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 25'><path fill='currentColor' d='M16.578 16.085l6.07 6.07-1.414 1.413-6.173-6.172a8.984 8.984 0 1 1 1.517-1.311zm-6.594.883A6.984 6.984 0 1 0 9.984 3a6.984 6.984 0 0 0 0 13.968z' /></svg>
)



// WEBPACK FOOTER //
// ./src/components/Icons/Search.jsx